import validate from "/home/jenkins/workspace/Prod_style3d_Front_homesite/node_modules/.pnpm/nuxt@3.3.1_owy7tnx7ypbq24n4qrhteyndna/node_modules/nuxt/dist/pages/runtime/validate.js";
import guards_45global from "/home/jenkins/workspace/Prod_style3d_Front_homesite/apps/main/middleware/guards.global.ts";
export const globalMiddleware = [
  validate,
  guards_45global
]
export const namedMiddleware = {}